import { useState, useCallback } from "react";
import axios from "axios";
import API from "@/lib/api";

export function getToken() {
  return localStorage.getItem("ngxp_admin_token");
}

export function getStoredAdmin() {
  try {
    return JSON.parse(localStorage.getItem("ngxp_admin"));
  } catch {
    return null;
  }
}

export function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function useAdminAuth() {
  const [token, setToken] = useState(getToken);
  const [admin, setAdmin] = useState(getStoredAdmin);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = useCallback(async (username, password) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("ngxp_admin_token", data.token);
      localStorage.setItem("ngxp_admin", JSON.stringify(data.admin));
      setToken(data.token);
      setAdmin(data.admin);
      return true;
    } catch (err) {
      setError(err.response?.data?.error || "Invalid credentials");
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ngxp_admin_token");
    localStorage.removeItem("ngxp_admin");
    setToken(null);
    setAdmin(null);
  }, []);

  return { token, admin, loading, error, login, logout, isAuthenticated: !!token };
}
